module.exports = __webpack_public_path__ + "img/local-14.1e031636.jpg";